import React, { useContext, useMemo } from 'react';
import dynamic from 'next/dynamic';
import Header from 'components/Layout/Header';
import { MedicalCategoryPropertyContext } from 'contexts/MedicalCategoryPropertyContext';
import { LocationContext } from 'contexts/LocationContext';
import { useRouter } from 'next/router';
import { FunnelContext } from 'contexts/FunnelContext';
import { AnalyticsContext } from 'contexts/AnalyticsContext';

import useUserAgent from 'hooks/useUserAgent';
import useNavigation, { PageName } from 'hooks/useNavigation';
import GardasilBannerImage from 'assets/images/curationBanner/img_banner_gardasil.png';
import MedicalCategoryTab from '../MedicalCategoryTab';
import { CategoryContext } from '../../../../contexts/CategoryContext';
import { Banner } from './styles';

const LocationPickerModal = dynamic(() => import('../LocationPickerModal'), { ssr: false });

export default function MedicalServicesPage() {
  const { openLocationPickerModal, setOpenLocationPickerModal } = useContext(MedicalCategoryPropertyContext);
  const { coordinate, setCoordinate } = useContext(LocationContext);
  const { selectedCuration } = useContext(CategoryContext);
  const router = useRouter();
  const { routerPush } = useNavigation();
  const { funnel } = useContext(FunnelContext);
  const { trackEvent } = useContext(AnalyticsContext);
  const { isBrowser } = useUserAgent();

  const queryString = useMemo(() => {
    const queryStringIndex = router.asPath.indexOf('?');
    if (queryStringIndex >= 0) {
      const querySubString = router.asPath?.substring(queryStringIndex);
      return querySubString;
    }
    return `?funnel=${funnel}`;
  }, [funnel, router]);

  const banner = useMemo(() => {
    if (selectedCuration?.id === '53' || selectedCuration?.id === '27') {
      return { img: GardasilBannerImage, type: 'gardasil' };
    }
    return null;
  }, [selectedCuration]);

  const onClinkBanner = (bannerType: string) => {
    trackEvent('clinic_productList_curationBanner_click', {
      curationId: selectedCuration.id,
      curationName: selectedCuration.name,
    });

    switch (bannerType) {
      case 'gumguard':
        {
          const url =
            'https://www.coupang.com/vp/products/5659684732?itemId=9285599097&vendorItemId=76571093838&q=%EA%B2%80%EA%B0%80%EB%93%9C&itemsCount=36&searchId=b9849f06bc954552b5b277cd0324bb56&rank=1&isAddedCart=';

          if (isBrowser) {
            window.open(url);
          } else {
            window.location.href = `goodoc://app/web?uri=${encodeURIComponent(url)}&headerShown=true`;
          }
        }
        break;
      case 'orientalmedical':
        routerPush(PageName.contentOrientalMedical);
        break;
      case 'gardasil':
        routerPush(PageName.gardasil);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Header />
      {banner && (
        <img
          className={Banner}
          src={banner.img}
          onClick={() => {
            onClinkBanner(banner.type);
          }}
          alt="curation banner"
        />
      )}
      <MedicalCategoryTab />
      {openLocationPickerModal && (
        <LocationPickerModal
          coordinate={coordinate}
          setOpenModal={setOpenLocationPickerModal}
          setPickLocation={setCoordinate}
        />
      )}
    </>
  );
}
